// src/theme/themeConfig.js
// Single source of truth for the portal's 5 selectable themes. Consumed by
// ThemeProvider (validation/default/persistence) and by the My Profile
// "Portal Appearance" section (rendering the preview cards) so the two
// never drift out of sync.
//
// Applying a theme is just switching the `data-theme` attribute on <html>
// (see ThemeProvider.jsx) -- the actual colors/radii/etc. per theme live in
// src/styles/themes.css as CSS custom-property overrides, not here.

export const THEME_STORAGE_KEY = "portal-theme";

export const THEMES = [
  {
    id: "modern-dark",
    name: "Modern Dark",
    description: "The current sleek, minimal dashboard -- near-black surfaces with red accents.",
    swatches: ["#050505", "#151515", "#E82135", "#F5F5F5"],
  },
  {
    id: "leo-legacy",
    name: "Leo Legacy",
    description: "A prestigious heritage look -- navy sidebar, ivory content, legacy gold accents.",
    swatches: ["#071A33", "#F7F2E7", "#D4AF37", "#17202A"],
  },
  {
    id: "royal-crimson",
    name: "Royal Crimson",
    description: "A premium executive theme -- deep crimson surfaces with restrained gold highlights.",
    swatches: ["#0B090A", "#48080F", "#C8A96A", "#FFFFFF"],
  },
  {
    id: "executive-light",
    name: "Executive Light",
    description: "A clean, bright SaaS-style dashboard built for readability and clarity.",
    swatches: ["#F5F7FA", "#FFFFFF", "#C91F37", "#151515"],
  },
  {
    id: "midnight-leo",
    name: "Midnight Leo",
    description: "A modern Leo-inspired look -- midnight navy with blue and gold highlights.",
    swatches: ["#050D1A", "#0868AC", "#D6B04A", "#F8FAFC"],
  },
  {
    id: "retro-system",
    name: "Retro System",
    description: "A nostalgic 1990s desktop look -- beveled gray panels, navy highlights, boxy UI.",
    swatches: ["#C0C0C0", "#000080", "#008080", "#000000"],
  },
  {
    id: "terminal-green",
    name: "Terminal Green",
    description: "A nostalgic old computer-terminal look -- monochrome green on black, monospace UI.",
    swatches: ["#000000", "#33FF33", "#001A00", "#FFB000"],
  },
];

export const VALID_THEME_IDS = THEMES.map((t) => t.id);
export const DEFAULT_THEME_ID = "modern-dark";

export function isValidTheme(id) {
  return VALID_THEME_IDS.includes(id);
}
